module.exports = __webpack_public_path__ + "static/media/D_10.f1dfb066.png";